
export class SettingsParkingRuleType {
    constructor(
        public id: number = null,
        public name: string = '',
        public passTypeSchedule: any = {
            repeatable: false,
            repeatEvery: {number: null, selectValue: ''},
            scheduleDays: [],
            startTime: null,
            endTime: null,
            startDayNumber: null,
            endDayNumber: null
        },
        public passTypeScheduleSliding: any = {
            pslidingSequenceType: '',
            pslidingPeriodCount: null
        },
        public maxTotalPassTypeCount: number = null,
        public maxTotalPassTypeSequenceType: string = '',
        public maxOfDaysPerBooking: number = null,
        public maxTimeForAdvancedBookingCount: number = null,
        public maxTimeForAdvancedBookingSequenceType: string = '',
        public requiresManagerApproval: boolean = false,
        public fee: number = null,
        public feeEnabledStatus: boolean = false,
        public maxPerSuiteCount: number = null,
        public maxPerSuiteSequenceType: string = '',
        public maxPerLicensePlateCount: number = null,
        public maxPerLicensePlateSequenceType: string = '',
        public allowOverlimitBooking: boolean = false,
        public printSuiteOnParkingPass: boolean = false,
        public doNotAllowResidentsPlates: boolean = false,
        public allowSelfPrintingByResidents: boolean = false,
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/SettingsParkingRuleType.ts